export default __webpack_public_path__ + "static/media/inicial.8414e478.png";